module.exports = __webpack_public_path__ + "img/yiyao_xuezhi_suoluetu.a89416eb.png";